import UserView from 'src/sections/management/user/view/user-view';

export default function User() {
  return <UserView />;
}
